/**
 * The family registry (plan §4.1): every family the framework knows. Intake assembles its
 * prompt and schema from here; the store, Shape and exports find a design's family here.
 * Build order (plan §4.7): grid → staggered → cube → offset-grid → free-grid (pilot-v1 R2-07).
 */
import type { Design } from '../domain/schemas';
import type { Family } from './registry-types';
import { GRID_FAMILY } from './grid-bookcase/index';
import { STAGGERED_FAMILY } from './staggered-cantilever/index';
import { CUBE_FAMILY } from './cube-storage/index';
import { OFFSET_FAMILY } from './offset-grid/index';
import { FREE_FAMILY } from './free-grid/index';

export const FAMILIES: readonly Family[] = Object.freeze([GRID_FAMILY as Family, STAGGERED_FAMILY as Family, CUBE_FAMILY as Family, OFFSET_FAMILY as Family, FREE_FAMILY as Family]);

export const FAMILY_IDS: readonly string[] = Object.freeze(FAMILIES.map((f) => f.definition.id));

/** The family with this id (or one of its older aliases), or null. */
export function getFamily(id: string | null | undefined): Family | null {
  if (!id) return null;
  return FAMILIES.find((f) => f.definition.id === id || f.definition.aliases?.includes(id)) ?? null;
}

/** A design's family (designs from the first slice carry the old single-bay id). */
export function familyOf(design: Pick<Design, 'family'>): Family {
  return getFamily(design.family) ?? FAMILIES[0]!;
}

export const familyLabel = (id: string | null | undefined): string => getFamily(id)?.definition.label ?? 'Unknown style';
